import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  taskToView: 0,
  relevantUserPersonId: 0,
  taskableGroups: [],
  tasks: [],
};

const sortTaskList = (inList) => {
  const copy = inList.slice();
  copy.sort((ts1, ts2) => ts1.nextDeadline - ts2.nextDeadline);
  return copy;
};

export const taskInfoSlice = createSlice({
  name: 'taskInfo',
  initialState: initialState,
  reducers: {
    clearTaskInfo: () => {
      return initialState;
    },

    setTaskInfo: (state, action) => {
      const taskInfo = action.payload;
      const sortedTasks = sortTaskList(taskInfo.tasks);
      return { ...taskInfo, tasks: sortedTasks };
    },

    addTask: (state, action) => {
      const newTask = action.payload;
      const currentTasks = state.tasks;
      const filteredTasks = currentTasks.filter((t) => t.id !== newTask.id);
      const extendedTasks = filteredTasks.concat(newTask);
      const sortedTasks = sortTaskList(extendedTasks);
      const newState = { ...state, tasks: sortedTasks };
      return newState;
    },

    addTaskableGroup: (state, action) => {
      const newGroup = action.payload;
      const current = state.taskableGroups;
      const augmented = current.some((g) => g.id === newGroup.id) ? current : current.concat(newGroup);
      const newState = { ...state, taskableGroups: augmented };
      return newState;
    },

    deleteTaskWithId: (state, action) => {
      const idOfTaskToDelete = action.payload;
      const currentTasks = state.tasks;
      const filteredList = currentTasks.filter((t) => t.id !== idOfTaskToDelete);
      return { ...state, tasks: filteredList };
    },

    replaceTask: (state, action) => {
      const alteredTask = action.payload;
      const currentTasks = state.tasks;
      const filteredTasks = currentTasks.filter((t) => t.id !== alteredTask.id);
      const newList = [...filteredTasks, alteredTask];
      const sortedTasks = sortTaskList(newList);
      return { ...state, tasks: sortedTasks };
    },
  },
});

export const { clearTaskInfo, setTaskInfo, addTask, addTaskableGroup, deleteTaskWithId, replaceTask } =
  taskInfoSlice.actions;

export default taskInfoSlice.reducer;
